export const reactAppUrl = process.env.REACT_APP_URL;

export const backendUrl = process.env.REACT_APP_BACK_URL;